import Typography from '@/ui/components/typography'
import { ActionButton } from '@/ui/components/buttons/action'
import { InfoBanner } from '@/ui/components/BannerAlert/InfoBanner'
import {
    InfoBannerWrapper,
    ProviderInfoWrapper,
} from '../../FraudDefenseMarketing.styles'
import { IntegrationUpdateBannerProps } from './IntegrationUpdateBanner.types'

const IntegrationUpdateBanner = ({
    dataTestId,
    providerIcon,
    providerDisplayName,
    isLoading,
    onClick,
    buttonTestId,
}: IntegrationUpdateBannerProps) => {
    return (
        <InfoBannerWrapper>
            <ProviderInfoWrapper>
                {providerIcon}
                <Typography variant="s-regular">
                    {providerDisplayName}
                </Typography>
            </ProviderInfoWrapper>
            <InfoBanner
                dataTestId={dataTestId}
                variant="warning"
                title={
                    <Typography variant="s-semibold">
                        Update integration is required to enable Fraud Defense
                    </Typography>
                }
                description="Account is already connected and being monitored for security posture issues. To access additional security services, including Fraud Defense, a quick and easy integration update is required."
                primaryButton={
                    <ActionButton
                        data-testid={buttonTestId}
                        text={isLoading ? 'Connecting to account' : 'Update'}
                        onClick={onClick}
                        loading={isLoading}
                        disabled={isLoading}
                    />
                }
            />
        </InfoBannerWrapper>
    )
}

export default IntegrationUpdateBanner
